// extracted by mini-css-extract-plugin
export default {"root":"Zigojo","suffix":"XqjX1Y","suffixIcon":"EZEIQ1"};